import { ProductStickyBar } from "./theme.js";
  // Extend it
  class CustomProductStickyBar extends HTMLElement {
    constructor() {
      super(...arguments);
      this.display();
    }

    display() {
      const form_id = this.getAttribute("form");
      const selector = document.forms[form_id];
      const stickyBar = document.querySelector('.product-sticky-bar');
      function callback(entries, observer) {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
          } 
          else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }
      let observer = new IntersectionObserver(callback);
      observer.observe(selector);
    }
  }

  // Create the custom elements
  window.customElements.define('custom-product-sticky-bar', CustomProductStickyBar);

document.addEventListener('variant:change', function(event) {
    let newVariant = event.detail.variant; // Gives you access to the whole variant details
    let previousVariant = event.detail.previousVariant; // Gives you access to the previous variant details
    const productDiscount = document.querySelector('.Price--discount');
    if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
        return; // The price do not have changed so let's return to avoid changing the DOM for nothing
      }
      if (newVariant['compare_at_price'] > newVariant['price'] && productDiscount) {
        const discount = Math.round((newVariant['compare_at_price'] - newVariant['price']) * 100 / newVariant['compare_at_price']);
        productDiscount.innerHTML = "<span class=\"Price--discount\" >".concat("(-", discount, "%)", "</span>");
      }
});  

//loyalty page
document.addEventListener('DOMContentLoaded', function () {
  const is_english = location.pathname.includes('/en/') || location.pathname === '/en';
  const is_german = location.href.includes('.de');

  if (is_english || is_german) {
    setTimeout(translateWelcomePopup, 1000);
  }

  if (window.location.href.includes('rewards')) {
    if (is_english || is_german) {
      setTimeout(initializeLoyaltyPage, 1000);
    }
  }

});

function translateWelcomePopup() {
  const selectors = {
    welcomeNotificationMessage: '.lion-notification__message',
    welcomeNotificationButton: '.lion-notification__action-button',
  }

  const themeStrings = window.themeVariables.strings;

  updateInnerHTML(selectors.welcomeNotificationMessage, themeStrings.welcomePopupTitle);  
  updateInnerHTML(selectors.welcomeNotificationButton, themeStrings.welcomePopupButton);  
}

function initializeLoyaltyPage() {
  const selectors = {
    firstSectionTitle: ".lion-header__join-today .h3",
    intro: "[data-i18n-key='sdk.integrated_page.welcome_guest.join_with_incentive']",
    redeemHeading: '.lion-redeem__heading h3',
    availableRewardsHeading: '.lion-available-rewards__heading h3',
    earnPointsHeading: '.lion-earn__heading h3',
    levelsHeading: '.lion-tiers-overview__heading h3',
    historyHeading: '.lion-account-history__heading h3',
    faqHeading: '.lion-faq__heading h3',
    faqSubheading: '.lion-faq-list__description',
    faqTitles: '.lion-faq-list__question-header',
    faqContents: '.lion-faq-list__question-answer',
    pointsRecap: ".lion-header__your-points",
    pendingPoints: ".lion-header__pending-points",
    points: ".lion-reward-item__cost .text, .lion-rule-item__points .text, .lion-header__your-points, .lion-tier-box__purchase-rule-points .text",
    navigationMenuItems: '.lion-header__nav a',
    benefitsItems: '.lion-rule-item__title',
    benefitsActions: '.lion-rule-item__actions button',
    morePointsNeeded: '[data-i18n-key="ui.dashboard.redeem_points.more_points_needed"]',
    noRewards: '[data-i18n-key="ui.dashboard.redeem_points.no_rewards"]',
    spend: '[data-i18n-key="ui.dashboard.tiers.spend_amount"]',
    emptyHistory: '[data-i18n-key="ui.dashboard.history.empty_state"]',
    tableDate: '[data-i18n-key="ui.general.date"]',
    tableType: '[data-i18n-key="ui.general.type"]',
    tableAction: '[data-i18n-key="ui.general.action"]',
    tablePoints: '[data-i18n-key="ui.general.points_plural"]',
    tableStatus: '[data-i18n-key="ui.general.status"]',
    tier0: '.lion-tier-box--0 .lion-tier-box__sub-title',
    joinButton: '.lion-header__join-buttons a:first-child',
    loginButton: '.lion-header__join-buttons a:last-child',
    youAreHere: '.lion-tier-box__you-are-here',
  };

  const themeStrings = window.themeVariables.strings;

  updateInnerHTML(selectors.firstSectionTitle, themeStrings.loyaltyPageTitle);
  updateIntro(selectors.intro, themeStrings.loyaltyPageTitle, themeStrings.loyaltyPageDescription);
  updateMultipleElements(selectors.redeemHeading, themeStrings.redeemHeading);
  updateMultipleElements(selectors.availableRewardsHeading, themeStrings.availableRewardsHeading);
  updateMultipleElements(selectors.earnPointsHeading, themeStrings.earnPointsHeading);
  updateMultipleElements(selectors.levelsHeading, themeStrings.levelsHeading);
  updateMultipleElements(selectors.historyHeading, themeStrings.historyHeading);
  updateMultipleElements(selectors.faqHeading, themeStrings.faqHeading);
  updateMultipleElements(selectors.faqSubheading, themeStrings.faqSubheading);
  updatePointsRecap(selectors.pointsRecap, themeStrings.pointsRecap);
  updatePendingPoints(selectors.pendingPoints, themeStrings.pointsPending);
  updateMultipleElements(selectors.noRewards, themeStrings.no_rewards);
  updateMultipleElements(selectors.emptyHistory, themeStrings.empty_history);
  updateMultipleElements(selectors.youAreHere, themeStrings.youAreHere);
  updateMultipleElements(selectors.tableDate, themeStrings.tableDate);
  updateMultipleElements(selectors.tableType, themeStrings.tableType);
  updateMultipleElements(selectors.tableAction, themeStrings.tableAction);
  updateMultipleElements(selectors.tablePoints, themeStrings.tablePoints);
  updateMultipleElements(selectors.tableStatus, themeStrings.tableStatus);
  updateMultipleElements(selectors.morePointsNeeded, themeStrings.more_points_needed);
  updateSpend(selectors.spend, themeStrings.spend);
  updateMultipleElements(selectors.tier0, themeStrings.start_here);
  updateMultipleElements(selectors.joinButton, themeStrings.join);
  updateMultipleElements(selectors.loginButton, themeStrings.login);
  updateNavigationMenu(selectors.navigationMenuItems, themeStrings);
  updateFaqTitles(selectors.faqTitles, themeStrings);
  updateFaqContents(selectors.faqContents, themeStrings);
  updateBenefitsItems(selectors.benefitsItems, themeStrings);
  updateBenefitsActions(selectors.benefitsActions, themeStrings);
  updatePoints(selectors.points, themeStrings);
}

function updateInnerHTML(selector, content) {
  const element = document.querySelector(selector);
  if (element) element.innerHTML = content;
}

function updateIntro(selector, title, description) {
  const element = document.querySelector(selector);
  if (element) {
    element.innerHTML = `<h1 class="h3">${title}</h1> <br/>${description}`;
  }
}

function updateMultipleElements(selector, content) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    element.innerHTML = content;
  });
}

function updatePointsRecap(selector, content) {
  const element = document.querySelector(selector);
  if (element) {
    element.innerHTML = element.innerHTML.replace('Hai', content);
  }
}

function updatePendingPoints(selector, content) {
  const element = document.querySelector(selector);
  if (element) {
    element.innerHTML = element.innerHTML.replace('in sospeso', content);
  }
}

function updateSpend(selector, content) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    element.innerHTML = element.innerHTML.replace('Spendi', content);
  });
}

function updateNavigationMenu(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element, index) => {
    element.textContent = strings[`header_${index + 1}`];
  });
}

function updateFaqTitles(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element, index) => {
    if(index >= 14) {
      const key = `faq_${index + 1 - 14}_title`;
      const formattedString = strings[key].replace(/&#39;/g, '\'');
      element.textContent = formattedString;
    }
    else {
      const key = `faq_${index + 1}_title`;
      const formattedString = strings[key].replace(/&#39;/g, '\'');
      element.textContent = formattedString;
    }
    
  });
}

function updateFaqContents(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element, index) => {
    if(index >= 14) {
      const key = `faq_${index + 1 - 14}_content`;
      const formattedString = strings[key].replace(/&#39;/g, '\'');
      element.innerHTML = formattedString;
    }
    else {
      const key = `faq_${index + 1}_content`;
      const formattedString = strings[key].replace(/&#39;/g, '\'');
      element.innerHTML = formattedString;
    }
  });
}

function updateBenefitsItems(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    if (element.textContent.includes('acquisto')) {
      element.textContent = strings.make_a_purchase;
    } else if (element.textContent.includes('account')) {
      element.textContent = strings.create_account;
    } else if (element.textContent.includes('Instagram')) {
      element.textContent = strings.follow_instagram;
    } else if (element.textContent.includes('mailing list')) {
      element.textContent = strings.newsletter;
    }
  });
}

function updateBenefitsActions(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    if (element.textContent.includes('saperne')) {
      element.textContent = strings.ctaLearnMore;
    } else if (element.textContent.includes('Segui')) {
      element.textContent = strings.ctaFollowUs;
    } else if (element.textContent.includes('giorni')) {
      element.textContent = element.textContent.replace('giorni', strings.ctaBirthday);
    } else if (element.textContent.includes('amico')) {
      element.textContent = strings.ctaReferral;
    }
  });
}

function updatePoints(selector, strings) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    if (element.innerHTML.includes('punti per')) {
      element.innerHTML = element.innerHTML.replace('punti per', strings.points_for);
    } else {
      element.innerHTML = element.innerHTML.replace('punti', strings.points);
    }
  });
}

//collection description
if(window.location.href.indexOf('collections') > -1){
  const read_more = document.querySelector('#read-more');
  const collectionDescription = document.querySelector('#collection-description');

  // add class hide to read_more and class open to collectionDescription
    if(read_more && collectionDescription){
      read_more.addEventListener('click', function(){
        if(collectionDescription.classList.contains('open')){
          collectionDescription.classList.remove('open');
          read_more.textContent = window.themeVariables.strings.read_more;
          return;
        }
        collectionDescription.classList.add('open');
        read_more.textContent = window.themeVariables.strings.read_less;
      })
    }
}